import { render, staticRenderFns } from "./root-doctor-messages.vue?vue&type=template&id=76d74444"
import script from "./root-doctor-messages.vue?vue&type=script&lang=js"
export * from "./root-doctor-messages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports